// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { CompleteStudentOnboardingData, CompleteStudentOnboardingErrors, CompleteStudentOnboardingResponses, CreateTutorCertificationData, CreateTutorCertificationErrors, CreateTutorCertificationResponses, CreateTutorEducationData, CreateTutorEducationErrors, CreateTutorEducationResponses, CreateUserInterestData, CreateUserInterestErrors, CreateUserInterestResponses, DeleteTutorCertificationData, DeleteTutorCertificationErrors, DeleteTutorCertificationResponses, DeleteTutorEducationData, DeleteTutorEducationErrors, DeleteTutorEducationResponses, DeleteUserInterestData, DeleteUserInterestErrors, DeleteUserInterestResponses, FetchActivePlansData, FetchActivePlansResponses, FetchCoursesData, FetchCoursesErrors, FetchCoursesResponses, FetchHolidaysData, FetchHolidaysResponses, FetchLevelsData, FetchLevelsResponses, GetLectureByIdData, GetLectureByIdErrors, GetLectureByIdResponses, GetTutorCertificationsData, GetTutorCertificationsErrors, GetTutorCertificationsResponses, GetTutorEducationsData, GetTutorEducationsErrors, GetTutorEducationsResponses, GetUserInterestsData, GetUserInterestsErrors, GetUserInterestsResponses, LoginWithGoogleData, LoginWithGoogleErrors, LoginWithGoogleResponses, LogoutAllData, LogoutAllErrors, LogoutAllResponses, LogoutData, LogoutResponses, RefreshTokenData, RefreshTokenErrors, RefreshTokenResponses, SaveOnboardingProgressData, SaveOnboardingProgressErrors, SaveOnboardingProgressResponses, UpdateTutorCertificationData, UpdateTutorCertificationErrors, UpdateTutorCertificationResponses, UpdateTutorEducationData, UpdateTutorEducationErrors, UpdateTutorEducationResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * logout
 */
export const logout = <ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>) => (options.client ?? client).delete<LogoutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/logout',
    ...options
});

/**
 * logout_all
 */
export const logoutAll = <ThrowOnError extends boolean = false>(options: Options<LogoutAllData, ThrowOnError>) => (options.client ?? client).delete<LogoutAllResponses, LogoutAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/logout_all',
    ...options
});

/**
 * refresh
 */
export const refreshToken = <ThrowOnError extends boolean = false>(options: Options<RefreshTokenData, ThrowOnError>) => (options.client ?? client).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/auth/refresh',
    ...options
});

/**
 * Authenticate with Google OAuth
 */
export const loginWithGoogle = <ThrowOnError extends boolean = false>(options: Options<LoginWithGoogleData, ThrowOnError>) => (options.client ?? client).post<LoginWithGoogleResponses, LoginWithGoogleErrors, ThrowOnError>({
    url: '/auth/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch all active courses
 */
export const fetchCourses = <ThrowOnError extends boolean = false>(options?: Options<FetchCoursesData, ThrowOnError>) => (options?.client ?? client).get<FetchCoursesResponses, FetchCoursesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fetch-courses',
    ...options
});

/**
 * Fetch a single lecture by ID
 */
export const getLectureById = <ThrowOnError extends boolean = false>(options: Options<GetLectureByIdData, ThrowOnError>) => (options.client ?? client).get<GetLectureByIdResponses, GetLectureByIdErrors, ThrowOnError>({ url: '/lectures/{id}', ...options });

/**
 * Fetch active subscription plans
 */
export const fetchActivePlans = <ThrowOnError extends boolean = false>(options?: Options<FetchActivePlansData, ThrowOnError>) => (options?.client ?? client).get<FetchActivePlansResponses, unknown, ThrowOnError>({ url: '/fetch-active-plans', ...options });

/**
 * Fetch all proficiency levels
 */
export const fetchLevels = <ThrowOnError extends boolean = false>(options?: Options<FetchLevelsData, ThrowOnError>) => (options?.client ?? client).get<FetchLevelsResponses, unknown, ThrowOnError>({ url: '/fetch-levels', ...options });

/**
 * Fetch upcoming holidays
 */
export const fetchHolidays = <ThrowOnError extends boolean = false>(options?: Options<FetchHolidaysData, ThrowOnError>) => (options?.client ?? client).get<FetchHolidaysResponses, unknown, ThrowOnError>({ url: '/fetch-holidays', ...options });

/**
 * Fetch tutor's education history
 */
export const getTutorEducations = <ThrowOnError extends boolean = false>(options: Options<GetTutorEducationsData, ThrowOnError>) => (options.client ?? client).get<GetTutorEducationsResponses, GetTutorEducationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/tutor-educations',
    ...options
});

/**
 * Create a new education entry
 */
export const createTutorEducation = <ThrowOnError extends boolean = false>(options: Options<CreateTutorEducationData, ThrowOnError>) => (options.client ?? client).post<CreateTutorEducationResponses, CreateTutorEducationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tutor-educations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an education entry
 */
export const deleteTutorEducation = <ThrowOnError extends boolean = false>(options: Options<DeleteTutorEducationData, ThrowOnError>) => (options.client ?? client).delete<DeleteTutorEducationResponses, DeleteTutorEducationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tutor-educations/{id}',
    ...options
});

/**
 * Update an education entry
 */
export const updateTutorEducation = <ThrowOnError extends boolean = false>(options: Options<UpdateTutorEducationData, ThrowOnError>) => (options.client ?? client).put<UpdateTutorEducationResponses, UpdateTutorEducationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tutor-educations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch tutor's certifications
 */
export const getTutorCertifications = <ThrowOnError extends boolean = false>(options: Options<GetTutorCertificationsData, ThrowOnError>) => (options.client ?? client).get<GetTutorCertificationsResponses, GetTutorCertificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/tutors-certifications',
    ...options
});

/**
 * Create a new certification entry
 */
export const createTutorCertification = <ThrowOnError extends boolean = false>(options: Options<CreateTutorCertificationData, ThrowOnError>) => (options.client ?? client).post<CreateTutorCertificationResponses, CreateTutorCertificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tutors-certifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a certification entry
 */
export const deleteTutorCertification = <ThrowOnError extends boolean = false>(options: Options<DeleteTutorCertificationData, ThrowOnError>) => (options.client ?? client).delete<DeleteTutorCertificationResponses, DeleteTutorCertificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tutors-certifications/{id}',
    ...options
});

/**
 * Update a certification entry
 */
export const updateTutorCertification = <ThrowOnError extends boolean = false>(options: Options<UpdateTutorCertificationData, ThrowOnError>) => (options.client ?? client).put<UpdateTutorCertificationResponses, UpdateTutorCertificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/tutors-certifications/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fetch user's interests
 */
export const getUserInterests = <ThrowOnError extends boolean = false>(options: Options<GetUserInterestsData, ThrowOnError>) => (options.client ?? client).get<GetUserInterestsResponses, GetUserInterestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/{userId}/interests',
    ...options
});

/**
 * Remove an interest from user's profile
 */
export const deleteUserInterest = <ThrowOnError extends boolean = false>(options: Options<DeleteUserInterestData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserInterestResponses, DeleteUserInterestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users-interests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add an interest to user's profile
 */
export const createUserInterest = <ThrowOnError extends boolean = false>(options: Options<CreateUserInterestData, ThrowOnError>) => (options.client ?? client).post<CreateUserInterestResponses, CreateUserInterestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users-interests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Complete student onboarding
 */
export const completeStudentOnboarding = <ThrowOnError extends boolean = false>(options: Options<CompleteStudentOnboardingData, ThrowOnError>) => (options.client ?? client).put<CompleteStudentOnboardingResponses, CompleteStudentOnboardingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/onboarding',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save partial onboarding progress
 *
 * Saves the current step progress so users can resume later
 */
export const saveOnboardingProgress = <ThrowOnError extends boolean = false>(options: Options<SaveOnboardingProgressData, ThrowOnError>) => (options.client ?? client).patch<SaveOnboardingProgressResponses, SaveOnboardingProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/users/onboarding/progress',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
